import type { Entity } from '@platform/entities/entity.class';
import { parseTableRef, Schema } from '@platform/shared/helpers/entity-helpers';

const schemas: Record<string, Map<string, typeof Entity>> = {
    [Schema.platform]: entitiesToMap(Schema.platform),
    [Schema.atb]: entitiesToMap(Schema.atb),
    [Schema.pusk]: entitiesToMap(Schema.pusk),
    [Schema.portal]: entitiesToMap(Schema.portal),
};

function entitiesToMap(schema: Schema | null, entities?: Record<string, typeof Entity>): Map<string, typeof Entity> {
    if (!entities) return new Map();
    let entitiesMap = Object.values(entities);
    if (schema != null) {
        entitiesMap = entitiesMap.filter((entity) => entity._tableInfo?.schemaName === schema);
    }
    return new Map(entitiesMap.map((entity) => [entity._tableInfo.tableName, entity]));
}

let entitiesIndex = entitiesToMap(null);

import('@platform/entities/index').then(({ DO_NOT_IMPORT_FROM_HERE: entities }) => {
    entitiesIndex = entitiesToMap(null, entities);
    schemas[Schema.platform] = entitiesToMap(Schema.platform, entities);
    schemas[Schema.atb] = entitiesToMap(Schema.atb, entities);
    schemas[Schema.pusk] = entitiesToMap(Schema.pusk, entities);
    schemas[Schema.portal] = entitiesToMap(Schema.portal, entities);
});

export function resolveEntity(tableName: string, schemaName?: keyof typeof Schema): typeof Entity | undefined {
    if (schemaName) {
        return schemas[schemaName]?.get(tableName);
    }
    return entitiesIndex.get(tableName);
}
export function resolveEntityFromEntityName(name: string): typeof Entity | undefined {
    for (const [_, entity] of entitiesIndex) {
        if (entity.name === name) return entity;
    }
    return undefined;
}

export function resolveEntityFromRef(ref: string): typeof Entity | undefined {
    const parsed = parseTableRef(ref);
    if (!parsed.tableName) return undefined;
    return resolveEntity(parsed.tableName, parsed.schemaName || undefined);
}

export function checkEntityFormConnected(tableName: string, schemaName?: keyof typeof Schema): boolean {
    const entity = resolveEntity(tableName, schemaName);
    return entity != null && Object.prototype.hasOwnProperty.call(entity, '_formFields');
}

export function resolveReference(reference: string) {
    return entitiesIndex.get(reference.replace(/_id$/, ''))?._tableInfo;
}
